import { SystemType } from '@agilelab/plugin-wb-builder-common';
import { WbCard, WbCardContent } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { TeamRoleCard } from './TeamRoleCard';
import { useTheme } from '@material-ui/core';
import {
  safeParseTeamRoleConfigFromSystemTypeRelation,
  witboostTeamRolesByRelation,
} from '@agilelab/plugin-wb-team-roles-common';

interface TeamRolesSettingsCardProps {
  systemType: SystemType;
}

export const TeamRolesSettingsCard: FC<TeamRolesSettingsCardProps> = ({
  systemType,
}) => {
  const theme = useTheme();

  return (
    <WbCard title="Team Roles Settings">
      <WbCardContent>
        {Object.entries(witboostTeamRolesByRelation).map(
          ([field, { displayName, description }]) => {
            const teamRoleConfig =
              safeParseTeamRoleConfigFromSystemTypeRelation(systemType, field);
            if (!teamRoleConfig) {
              return <></>;
            }
            return (
              <TeamRoleCard
                key={field}
                teamRole={teamRoleConfig}
                title={displayName}
                labelInfo={description}
                style={{ marginBottom: theme.spacing(2) }}
              />
            );
          },
        )}
      </WbCardContent>
    </WbCard>
  );
};
